import type { EntityValidationRules } from "../services/validationService";
import Enum from "./enum";
import type SystemComponentState from "./systemComponentState";
import type SystemComponentCode from "./systemComponentCode";

export default class SystemComponent extends Enum {
  id: string;
  state: SystemComponentState;
  code: SystemComponentCode | string;
}

export const SystemComponentValidationRules: EntityValidationRules<SystemComponent> = {
  name: {
    required: true,
  },
  state: {
    required: true,
  },
  code: {
    required: true,
  },
};
